import { patientActions, noteActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'
import { log } from '_services'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [patientActions.loadSuccess]: (state, action) => {
        return { ...state, ...action.payload.entities.admissions };
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        if (action.payload.patientsContainer.entities) {
            return { ...state, ...action.payload.patientsContainer.entities.admissions };
        } else {
            return state;
        }
    },
    [patientActions.closeSuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if (x.ptno === action.payload) {
                delete state[x.id];
            }
        })
    },
    // [patientActions.setUsePedsSuccess]: (state, action) => {
    //     state[action.payload.epno].usePedsTemplate = action.payload.usePeds;
    // },
    [patientActions.updateAdmissionContrainSuccess]: (state, action) => {
        state[action.payload.epno].contraindications = action.payload.contrain;
    },
    [patientActions.updateAdmissionContrainFailure]: (state, action) => {
        log.error('Error updating admission contraindications.  epno: ' + action.payload.epno + ' error: ' + action.payload.error);
    },
    [noteActions.updateContrainSuccess]: (state, action) => {
        state[action.payload.epno].contraindications = action.payload.value;
    },
    [patientActions.refreshAdmissionsSuccess]: (state, action) => {
        return { ...state, ...action.payload.entities.admissions };
    },
    [patientActions.enableRtmForAdmissionSuccess]: (state, action) => {
        state[action.payload.epno].isRTMEnabled = true;
    },
    [patientActions.showScribeOptionsSuccess]: (state, action) => {
        state[action.payload.epno].therapists = action.payload.therapists.entities.EPTHERAPISTS;
    },
})


